import { Link } from 'react-router-dom';



export default function Intro (){
  return (
    <div className='relative flex items-center justify-start w-full  contact-background rounded-t-3xl bottom-[22px]'>
        <div className='flex  items-start justify-end w-full gap-y-10 md:gap-0 md:flex-row '>
        <div className='flex flex-col  justify-center w-[100%] sm:w-[70%] md:w-[53%] px-16 pt-28 pb-32 rounded-t-3xl sm:rounded-l-3xl  md:rounded-tr-3xl text-[#303030] bg-[white] items-start gap-y-4 '>
            <h1 className='text-3xl font-extrabold md:text-4xl xl:text-6xl'>Let's<br/><span className='relative block bottom-[18px] md:bottom-[17px] left-[24px] md:left-[28px]'>Contact</span></h1>
            <p className=' text-[14px] lg:text-[15px] xl:text-[17px] w-[100%] sm:w-[95%] md:w-[85%] lg:w-[80%]'>You can reach me on <a href="https://www.linkedin.com/in/gulfam-haider-861016291/" className='text-black font-semibold underline hover:text-black' target="_blank" rel="noopener noreferrer" title='My LinkedIn'>LinkedIn</a>, <a target="_blank" rel="noopener noreferrer" title='My Fiverr' href="https://www.fiverr.com/gulfam207" className='text-black font-semibold underline hover:text-black'>Fiverr</a>, and other freelancing websites. These places make it easy to connect and work together. Whether it's LinkedIn for business, Fiverr for freelancing sites for projects, you can find me there. Feel free to message me on any of these platforms to talk about working together. I'm excited to hear from you and see what we can do together!</p>
            <Link to={'/my-projects'}>
        <button className=" px-4 text-sm rounded-3xl hover:bg-black hover:text-white hover:border-white py-[13px] font-medium transition-all duration-300 text-black bg-[#fdfdfd] border-[1px] border-black " title='Explore My Projects'>
       My Projects
        </button>
        </Link>    
        </div>
        
       
        </div>
    </div>
  )
}
